import { Form, Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const FormulaDecimalsField: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Form.Item style={{ width: 200 }} name={['style', 'decimals']} label={t('global:decimals', 'Desimaalit')}>
      <Select>
        <Select.Option value={0}>0</Select.Option>
        <Select.Option value={1}>1</Select.Option>
        <Select.Option value={2}>2</Select.Option>
        <Select.Option value={3}>3</Select.Option>
      </Select>
    </Form.Item>
  )
}

export default FormulaDecimalsField
